import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {PositionSearchResultModel, SuppliersService} from '../../../services/suppliers.service';
import {CoreService, ProleisObject} from '@proleis/proleis-rest-client';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {Observable} from 'rxjs';
import {FormControl} from '@angular/forms';
import {debounceTime, filter, map, switchMap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {NotificationService} from '@proleis/proleis-web-app';

@Component({
  selector: 'ps-search-position',
  templateUrl: 'search.position.dialog.component.html'
})
export class SearchPositionDialogComponent implements OnInit, OnDestroy {

  selection: ProleisObject;
  searchFormControl: FormControl;
  filteredOptions: Observable<any>;

  constructor(private dialogRef: MatDialogRef<SearchPositionDialogComponent>, private supplierService: SuppliersService,
              private coreService: CoreService, private router: Router, private notificationService: NotificationService) {
  }

  ngOnInit(): void {
    this.searchFormControl = new FormControl();
    this.filteredOptions = this.searchFormControl.valueChanges
      .pipe(
        debounceTime(250),
        filter(value => {
          return value.length >= 3;
        }),
        switchMap(value => this.queryDatabase(value).pipe(map(result => result.results)))
      );
  }

  ngOnDestroy() {
  }

  queryDatabase(value: string): Observable<PositionSearchResultModel> {
    return this.supplierService.searchPosition(value);
  }

  redirect() {
    if (this.selection.pboId !== 0) {
      this.router.navigate(['orders/' + this.selection.pboId + '/overview']);
      this.dialogRef.close();
    } else {
      this.notificationService.showNotification('Keine Bestellung zur gesuchten Aktivität gefunden!');
      this.dialogRef.close();
    }
  }

  displayWith(option: ProleisObject) {
    return option ? option.NAME : undefined;
  }

  onSelect(event: MatAutocompleteSelectedEvent) {
    this.selection = event.option.value;
    this.redirect();
  }

}
